import * as actionTypes from "../actionTypes";

export const getNextFormNr = function () {
  return { type: actionTypes.GET_NEXT_FORM_NR };
};
